import Link from 'next/link';

import { Button } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { applyTestIdData } from 'Utilities/helpers';

import styles from './SectionEmptyState.module.scss';

interface SectionEmptyStateProps {
	actionHref?: string;
	actionLabel?: React.ReactNode;
	imageSrc?: string;
	onClick?: () => void;
	testId?: string;
	text: React.ReactNode;
}

export const SectionEmptyState: React.FC<SectionEmptyStateProps> = ({
	actionHref,
	actionLabel,
	imageSrc,
	onClick,
	testId,
	text,
}) => {
	const isActionButtonVisible = actionLabel && actionHref;
	return (
		<div className={styles.container} {...applyTestIdData(testId || cypressIds.containers.pageSectionEmptyState)}>
			{imageSrc && (
				<div className={styles.imageWrapper}>
					<img className={styles.image} src={imageSrc} />
				</div>
			)}
			<div className={styles.content}>
				<div className={styles.text}>{text}</div>
				{isActionButtonVisible && (
					<div className={styles.button}>
						<Link legacyBehavior passHref href={actionHref}>
							<Button as="a" label={actionLabel} onClick={onClick} target="_blank" variant="secondary" />
						</Link>
					</div>
				)}
			</div>
		</div>
	);
};
